module.exports = __webpack_public_path__ + "img/pay-box-unknown-error.cbe7222a.svg";